import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, {
  IActionData,
  ITableColumn,
} from '@/components/common/CommonTable';
import DetailCard, { ICardDetail } from '@/components/common/DetailCard';
import Layout from '@/components/Layout/Layout';
import FullPageLoader from '@/components/loader/FullPageLoader';
import BackButton from '@/components/ui/BackButton';
import { IAssetResponse } from '@/interfaces/assets.model';
import { showToastNotification } from '@/utility/helper';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ITableData } from '../Assets/Assets';
import CardLayout from '@/components/Layout/CardLayout';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { IPageInfo } from '@/interfaces/common.model';
import useFilter from '@/hooks/useFilter';
import MainHeading from '@/components/common/MainHeading';
import PlusIcon from '@/components/Icons/PlusIcon';
import { RoutesLink } from '@/utility/RouteLinks';
import ViewIcon from '@/components/Icons/ViewIcon';
interface IpageStates extends IPageInfo {
  count: number;
  tableLoader: boolean;
  companyList: ITableData[];
  searchQuery: string;
}
const AssetCategoryDetail: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  // const [isViewModal, setIsViewModal] = useState<boolean>(false);
  const { id } = useParams();
  const location = useLocation();
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [assets, setAssets] = useState<ITableData[]>([]);
  const [pageStates, setPageStates] = useState<IpageStates>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    companyList: [],
    searchQuery: '',
  });
  // const [selectedDocument, setSelectedDocument] =
  //     useState<Partial<IDocument> | null>(null);
  const actionData: IActionData<ITableData>[] = [
    {
      label: 'View',
      className: 'btn btn-link ',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: ITableData) =>
        navigate(RoutesLink?.assetDetail + `/${data?.id}`),
    },
  ];
  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'name', label: 'Name' },
    { value: 'serialNumber', label: 'Serial No.' },
    { value: 'price', label: 'Price' },
    // { value: 'category', label: 'Category' },
    { value: 'assetStatus', label: 'Status' },
    // { value: 'description', label: 'Description' },
  ];

  useEffect(() => {
    if (id) {
      getAsset();
    }
  }, [id]);
  const getAsset = async () => {
    try {
      setIsLoading(true);
      const response: IAssetResponse = await callApi(
        API_URL + API_ENDPOINT.assetList + `?assetCategoryId=${id}`,
        {
          method: 'GET',
        },
      );
      if (response.status) {
        const newData: ITableData[] = response?.data?.asset?.map(
          (item, index: number) => ({
            ...item,
            index: index + 1,
            name: item?.name,
            assetCategory: item?.assetCategory?.name,
            serialNumber: item?.serialNo,
            price: item?.price,
            category: item?.assetCategory?.name,
            assetStatus: Number(item?.status),
            description: item.description,
            id: item.id,
          }),
        );
        setAssets(newData);
        setPageStates((prev) => ({
          ...prev,
          count: response?.data?.pageInfo?.total,
          total: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // const toggle = () => {
  //     setIsViewModal(!isViewModal);
  // };

  // const handleDocumentClick = (doc: IDocument | string) => {
  //     const url = typeof doc == 'string' ? doc : doc?.url;
  //     const docUrl = {
  //         url,
  //     };

  //     setSelectedDocument(docUrl);
  //     setIsViewModal(true);
  // };

  const cardDetails: ICardDetail[] = [
    { label: 'Name', value: location?.state?.data?.name },
    { label: 'Description', value: location?.state?.data?.description },
  ];
  const { pageChangeHandler, handleChangePageSize } = useFilter(
    pageStates,
    setPageStates,
  );
  return (
    <Layout>
      {isLoading ? (
        <FullPageLoader />
      ) : (
        <>
          <div className="content container-fluid">
            <BackButton label={'Asset Category'} isDetail={true} />
            <DetailCard cardDetails={cardDetails} />
            <MainHeading
              title="Assets List"
              buttonText="Add Asset"
              buttonIcon={<PlusIcon />}
              buttonLink={RoutesLink?.addAsset}
            />
            <CardLayout>
              <CommonTable
                tableHeading={tableHeading}
                tableData={assets}
                count={pageStates?.count}
                pageSize={filterDetails?.pageSize}
                isLoading={isLoading}
                ActionData={actionData}
                currentPage={pageStates?.currentPage}
                totalPages={pageStates?.totalPages}
                // handleStatusToggle={handleStatusToggle}
                pageChangeHandler={pageChangeHandler}
                handleChangePageSize={handleChangePageSize}
              />
            </CardLayout>
            {/* <div className="row">
                            <DetailCard
                                title="Documents"
                                documents={assetDetails?.documents}
                                handleDocumentClick={handleDocumentClick}
                            />
                        </div> */}
          </div>
          {/* <ViewDocumentModal
                        isOpen={isViewModal}
                        toggle={toggle}
                        selectedDocument={selectedDocument}
                    /> */}
        </>
      )}
    </Layout>
  );
};
export default AssetCategoryDetail;
